import { Injectable, Injector } from '@angular/core';
import {
  HttpErrorResponse, HttpHandler, HttpHeaderResponse, HttpInterceptor, HttpProgressEvent, HttpRequest, HttpResponse,
  HttpSentEvent, HttpUserEvent
} from '@angular/common/http';

import { AuthService } from '../auth/auth.service';
import { ClientApiService } from './api.service';
import { WebsiteTogglerService } from '../../dashboard/components/websites-toggler/services/website-toggler.service';
import { LoadingIndicatorService } from '../helpers/loading-indicator.service';
import { NotificationsService } from 'angular2-notifications';
import { environment } from '../../../environments/environment';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { catchError, finalize, switchMap, filter, take } from 'rxjs/operators';


@Injectable()
export class ApiInterceptorService implements HttpInterceptor {
  isRefreshingToken = false;
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  constructor(
    private notify: NotificationsService,
    private injector: Injector
  ) { }
  addToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
    // Inject serives
    const requestOptions: any = {};
    const auth = this.injector.get(AuthService);
    const togglerWebsite = this.injector.get(WebsiteTogglerService);
    const loadingIndicatorService = this.injector.get(LoadingIndicatorService);
    // emit onStarted event before request execution
    loadingIndicatorService.onStarted(req);

    if (req.url.includes(environment.apiUrl) || req.url.includes(environment.altApiUrl)) {

      const setParams = {
        apikey: token
      };

      const apiRoute = req.url.replace(environment.apiUrl, '').replace(environment.altApiUrl, '');
      if (auth.userProfile) {
        if (!environment.websiteBlackList.includes(apiRoute) && !auth.isAdmin) {
          // add filters[websiteId] param to every request with exclusions
          const currentWebsiteId = togglerWebsite.website ? togglerWebsite.website.id : '';
          if (apiRoute != 'locations') {
            setParams['filters[websiteId]'] = currentWebsiteId;
          }
          // add website_id param to every request with exclusions
          const websiteRequestMethods = ['POST', 'PUT', 'PATCH'];
          if (req.body && websiteRequestMethods.includes(req.method)) {
            if (req.body.website_id === undefined) {
              req.body.website_id = currentWebsiteId;
            }
          }
        }
      }
      requestOptions.setParams = setParams;
      return req.clone({setParams});
    } else {
      return req;
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
    const auth = this.injector.get(AuthService);
    const loadingIndicatorService = this.injector.get(LoadingIndicatorService);
    const token = auth.userProfile ? auth.userProfile.token : environment.apiKey;

    return next.handle(this.addToken(req, token))
    .pipe(
      catchError(error => {
        console.log(error);
        if (error instanceof HttpErrorResponse) {
          const apiService = this.injector.get(ClientApiService);
          return apiService.errorHandler(error);
          /*if (err.code === 500 && err.message === 'A Token was not found in the TokenStorage.') {
            // this.logoutUser(error);
            auth.logout();
            loadingIndicatorService.onFinished(req);
            return Observable.throw(error);
            // return this.handleTokenExpired(req, next);
          } else if (err.status_code === 500 && err.message === 'auth.not_able_to_refresh_token') {
            this.logoutUser(error);
            loadingIndicatorService.onFinished(req);
            return Observable.throw(error);
          } else if (err) {
            this.errorNotify(err);
            loadingIndicatorService.onFinished(req);
            return Observable.throw(error);
          }*/
        } else {
          return throwError(error);
        }
      }),
      finalize(() => loadingIndicatorService.onFinished(req))
    );
  }

  handleTokenExpired(req: HttpRequest<any>, next: HttpHandler) {
    const auth = this.injector.get(AuthService);
    const loadingIndicatorService = this.injector.get(LoadingIndicatorService);
    if (!this.isRefreshingToken) {
      this.isRefreshingToken = true;
      // Reset here so that the following requests wait until the token
      // comes back from the refreshToken call.
      this.tokenSubject.next(null);

      return auth.refreshToken()
      .pipe(
        switchMap((newToken: any) => {
          console.log(newToken);
          if (newToken.token) {
            auth.token = newToken.token;
            this.tokenSubject.next(newToken.token);
            return next.handle(this.addToken(req, newToken.token));
          }

          // If we don't get a new token, we are in trouble so logout.
          return this.logoutUser('');
        }),
        catchError(error => {
          console.error(error);
          loadingIndicatorService.onFinished(req);
          // If there is an exception calling 'refreshToken', bad news so logout.
          return this.logoutUser(error);
        }),
        finalize(() => {
          loadingIndicatorService.onFinished(req);
          this.isRefreshingToken = false;
        })
      );
    } else {
      return this.tokenSubject
      .pipe(
        filter(token => token != null),
        take(1),
        switchMap(token => {
          loadingIndicatorService.onFinished(req);
          return next.handle(this.addToken(req, token));
        })
      );
    }
  }
  logoutUser(error) {
    const auth = this.injector.get(AuthService);
    auth.logout();
    // Route to the login page (implementation up to you)
    return throwError(error);
  }
  errorNotify(error: any) {
    const err = error.error.error;
    console.log(error.error);
    if (err) {
      this.notify.error(err.code, err.message);
    } else if (error.error.errors) {
      const errs = error.error.errors;
      let msg = '';
      errs.forEach(el => {
        msg += el.property_path + ':' + el.message + '\n';
      });
      this.notify.error('Invalid fields', msg);
    } else {
      this.notify.error(error.status, error.error);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/core/api/api-interceptor.service.ts